import { useTranslation } from "react-i18next";
import { ContentHeader, MainContentArea } from "melco-ui";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { PurchasesList } from "../../components/billing/PurchasesList";

export const Purchases: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("billing");

  return (
    <MainContentArea
      header={
        <ContentHeader title={t("purchases.title")} breadcrumb={breadcrumb} />
      }
    >
      <PurchasesList />
    </MainContentArea>
  );
};
